module.exports = __webpack_public_path__ + "static/media/48393424_2308765832531928_5445765643653611520_o.dd9a4f15.jpg";